import { inject as service } from '@ember/service';
import Route from 'cio/routes/base';
import DS from 'ember-data';
import ObjectsController from 'cio/pods/objects/index/controller';

export default class ObjectsRoute extends Route {
  @service store!: DS.Store;

  model() {
    return this.store
      .peekAll('object-type')
      .toArray()
      .filter((ot) => !ot.get('isNew'));
  }

  redirect() {
    let objectTypes = this.model();
    if (objectTypes.length > 0) {
      this.router.transitionTo('objects.type', objectTypes[0].slug);
    }
  }

  activate() {
    let controller = this.controllerFor(this.routeName) as ObjectsController;
    controller.pollForObjectTypes.perform();
  }

  deactivate() {
    let controller = this.controllerFor(this.routeName) as ObjectsController;
    controller.pollForObjectTypes.cancelAll();
  }
}
